// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// allowed chart timeframes
export const TvChartSupportedResolutionArray = [
    '1',
    '2',
    '3',
    '5',
    '15',
    '30',
    /* '45', */
    '60',
    /* '120',
        '180', */
    '240',
    '1D',
    '1W',
    '1M',
    '12M'
];
Object.freeze(TvChartSupportedResolutionArray);
export var TvSessionIdEnum;
(function (TvSessionIdEnum) {
    TvSessionIdEnum["regular"] = "regular";
    TvSessionIdEnum["extended"] = "extended";
    TvSessionIdEnum["premarket"] = "premarket";
    TvSessionIdEnum["postmarket"] = "postmarket";
})(TvSessionIdEnum || (TvSessionIdEnum = {}));
export var VisiblePlotsSetEnum;
(function (VisiblePlotsSetEnum) {
    VisiblePlotsSetEnum["ohlcv"] = "ohlcv";
    VisiblePlotsSetEnum["ohlc"] = "ohlc";
    VisiblePlotsSetEnum["c"] = "c";
})(VisiblePlotsSetEnum || (VisiblePlotsSetEnum = {}));
export var SeriesFormatEnum;
(function (SeriesFormatEnum) {
    SeriesFormatEnum["price"] = "price";
    SeriesFormatEnum["volume"] = "volume";
})(SeriesFormatEnum || (SeriesFormatEnum = {}));
